/* ============================================
   TAANGO SHOPIFY THEME — Main JS
   ============================================ */
(function () {
  'use strict';

  /* ==========================================
     CART DRAWER
  ========================================== */
  const CartDrawer = {
    drawer: null,
    overlay: null,

    init() {
      this.drawer = document.getElementById('cart-drawer');
      this.overlay = document.getElementById('cart-drawer-overlay');

      document.querySelectorAll('[data-open-cart]').forEach(el => {
        el.addEventListener('click', e => { e.preventDefault(); this.open(); });
      });

      const closeBtn = document.getElementById('cart-drawer-close');
      if (closeBtn) closeBtn.addEventListener('click', () => this.close());
      if (this.overlay) this.overlay.addEventListener('click', () => this.close());
    },

    open() {
      return this.fetchAndRender().then(() => {
        this.drawer.classList.add('is-open');
        this.overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }).catch(() => { window.location.assign((window.Shopify?.routes?.root || '/') + 'cart'); });
    },

    close() {
      this.drawer.classList.remove('is-open');
      this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    },

    fetchAndRender() {
      return fetch((window.Shopify?.routes?.root || '/') + 'cart.js')
        .then(r => r.json())
        .then(cart => {
          this.renderBody(cart);
          this.renderFooter(cart);
          this.updateCount(cart.item_count);
        });
    },

    updateCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = 'Bag (' + count + ')';
      });
    },

    renderBody(cart) {
      const body = document.getElementById('cart-drawer-body');
      if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML = '<p class="cart-drawer-empty">Your bag is empty.</p>';
        return;
      }

      const fmt = new Intl.NumberFormat(undefined, {
        style: 'currency', currency: cart.currency || 'USD'
      });

      body.innerHTML = cart.items.map(item => {
        const variantLabel = item.variant_title && item.variant_title !== 'Default Title'
          ? '<div class="cart-drawer-item__variant">' + item.variant_title + '</div>'
          : '';
        return `
          <div class="cart-drawer-item" data-key="${item.key}">
            <div class="cart-drawer-item__image">
              <a href="${item.url}">
                <img src="${item.image}" alt="${item.product_title}" loading="lazy">
              </a>
            </div>
            <div class="cart-drawer-item__details">
              <div class="cart-drawer-item__top">
                <div class="cart-drawer-item__title">${item.product_title}</div>
                <div class="cart-drawer-item__price">${fmt.format(item.final_line_price / 100)}</div>
              </div>
              ${variantLabel}
              <div class="cart-drawer-item__qty-row">
                <span>Quantity: ${item.quantity}</span>
                <div class="cart-drawer-item__qty-controls">
                  <button class="cart-drawer-item__qty-btn" onclick="CartDrawer.changeQty('${item.key}', ${item.quantity - 1})" aria-label="Decrease">−</button>
                  <span class="cart-drawer-item__qty-num">${item.quantity}</span>
                  <button class="cart-drawer-item__qty-btn" onclick="CartDrawer.changeQty('${item.key}', ${item.quantity + 1})" aria-label="Increase">+</button>
                  <button class="cart-drawer-item__remove" onclick="CartDrawer.changeQty('${item.key}', 0)">Remove X</button>
                </div>
              </div>
            </div>
          </div>`;
      }).join('');
    },

    renderFooter(cart) {
      const footer = document.getElementById('cart-drawer-footer');
      if (!footer) return;

      if (cart.item_count === 0) { footer.innerHTML = ''; return; }

      const fmt = new Intl.NumberFormat(undefined, {
        style: 'currency', currency: cart.currency || 'USD'
      });

      footer.innerHTML = `
        <div class="cart-drawer-subtotal">
          <span class="cart-drawer-subtotal__label">Subtotal</span>
          <span class="cart-drawer-subtotal__amount">${fmt.format(cart.total_price / 100)}</span>
        </div>
        <p class="cart-drawer-note">All product is shipped from Austin, Texas. Sales tax and shipping will be calculated at checkout.</p>
        <a href="/checkout" class="cart-drawer-checkout">Checkout</a>
      `;
    },

    changeQty(key, qty) {
      fetch((window.Shopify?.routes?.root || '/') + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(r => r.json())
        .then(cart => {
          this.renderBody(cart);
          this.renderFooter(cart);
          this.updateCount(cart.item_count);
        });
    }
  };

  window.CartDrawer = CartDrawer;

  /* ==========================================
     PRODUCT FORM — color + size variant selection
  ========================================== */
  const ProductForm = {
    selectedColor: null,
    selectedSize: null,
    variants: [],
    allImages: [],

    init() {
      const form = document.getElementById('product-form');
      if (!form) return;

      this.variants = window.__taangoVariants || [];
      this.allImages = window.__taangoProductImages || [];

      // Detect which options exist
      const colorBtns = document.querySelectorAll('.variant-color-btn');
      const sizeBtns = document.querySelectorAll('.variant-size-btn');

      // Check URL for variant parameter
      const urlParams = new URLSearchParams(window.location.search);
      const urlVariantId = urlParams.get('variant');
      let preselectedVariant = this.variants.find(v => String(v.id) === form.querySelector('[name="id"]').value);

      if (urlVariantId) {
        preselectedVariant = this.variants.find(v => String(v.id) === urlVariantId) || preselectedVariant;
      }

      // Initialize selected values
      if (colorBtns.length > 0) {
        if (preselectedVariant) {
          // Find the color option from the preselected variant
          const colorIndex = parseInt(colorBtns[0].dataset.optionIndex);
          const targetColor = preselectedVariant.options[colorIndex];
          colorBtns.forEach(btn => {
            btn.classList.remove('is-selected');
            if (btn.dataset.color === targetColor) {
              btn.classList.add('is-selected');
              this.selectedColor = targetColor;
            }
          });
        }
        if (!this.selectedColor) {
          this.selectedColor = colorBtns[0].dataset.color;
        }
      }

      if (sizeBtns.length > 0) {
        if (preselectedVariant) {
          const sizeIndex = parseInt(sizeBtns[0].dataset.optionIndex);
          const targetSize = preselectedVariant.options[sizeIndex];
          sizeBtns.forEach(btn => {
            btn.classList.remove('is-selected');
            if (btn.dataset.size === targetSize) {
              btn.classList.add('is-selected');
              this.selectedSize = targetSize;
            }
          });
        }
        if (!this.selectedSize) {
          sizeBtns[0].classList.add('is-selected');
          this.selectedSize = sizeBtns[0].dataset.size;
        }
      }

      // If no color and no size options, just use first variant
      if (colorBtns.length === 0 && sizeBtns.length === 0 && this.variants.length > 0) {
        const inp = document.getElementById('variant-id-input');
        if (inp) inp.value = this.variants[0].id;
      }

      // Color button clicks
      colorBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          colorBtns.forEach(b => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');
          this.selectedColor = btn.dataset.color;
          this.updateVariant();
          this.updateGalleryForColor(this.selectedColor);
        });
      });

      // Size button clicks
      sizeBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          sizeBtns.forEach(b => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');
          sizeBtns.forEach(b => b.setAttribute('aria-pressed', String(b === btn)));
          this.selectedSize = btn.dataset.size;
          this.updateVariant();
        });
      });

      // Set initial variant
      this.updateVariant();
      this.updateSizeAvailability();

      // Filter gallery to show only first color's images initially
      if (this.selectedColor) {
        this.updateGalleryForColor(this.selectedColor);
      }

      // Form submit
      form.addEventListener('submit', e => {
        e.preventDefault();
        const inp = document.getElementById('variant-id-input');
        if (!inp || !inp.value) {
          Notification.show('Please select options');
          return;
        }
        this.addToCart();
      });
    },

    updateVariant() {
      // Find the variant that matches selected color + size
      const match = this.variants.find(v => {
        const opts = v.options || [];
        let colorMatch = true;
        let sizeMatch = true;

        // Check each option
        opts.forEach((opt, i) => {
          if (this.selectedColor && opt === this.selectedColor) colorMatch = true;
          if (this.selectedSize && opt === this.selectedSize) sizeMatch = true;
        });

        // More precise: match by checking all options contain our selections
        if (this.selectedColor && this.selectedSize) {
          return opts.includes(this.selectedColor) && opts.includes(this.selectedSize);
        } else if (this.selectedColor) {
          return opts.includes(this.selectedColor);
        } else if (this.selectedSize) {
          return opts.includes(this.selectedSize);
        }
        return false;
      });

      if (match) {
        const inp = document.getElementById('variant-id-input');
        if (inp) inp.value = match.id;
        this.updateAtcState(match.available);
        this.updateSizeAvailability();
        document.getElementById('product-form').dispatchEvent(new CustomEvent('taango:variant-change'));
      }
    },

    updateSizeAvailability() {
      const sizeBtns = document.querySelectorAll('.variant-size-btn');
      sizeBtns.forEach(btn => {
        const size = btn.dataset.size;
        let variant;
        if (this.selectedColor) {
          variant = this.variants.find(v =>
            v.options.includes(this.selectedColor) && v.options.includes(size)
          );
        } else {
          variant = this.variants.find(v => v.options.includes(size));
        }
        if (variant) {
          btn.disabled = !variant.available;
          btn.classList.toggle('is-unavailable', !variant.available);
        } else {
          btn.disabled = true;
          btn.classList.add('is-unavailable');
        }
      });
    },

    updateGalleryForColor(color) {
      const gallery = document.getElementById('product-gallery');
      if (!gallery) return;

      const colorImageIds = window.__taangoColorImageIds || {};
      const idsForColor = colorImageIds[color] || [];
      const items = gallery.querySelectorAll('.product-page__gallery-item');
      const colorLower = color.toLowerCase();

      // Collect all matching image IDs from both variant images AND alt text
      const matchingIds = new Set(idsForColor);

      items.forEach(item => {
        const alt = (item.dataset.imageAlt || '').toLowerCase();
        if (alt.includes(colorLower)) {
          matchingIds.add(parseInt(item.dataset.imageId));
        }
      });

      // If we found matches, filter to those; otherwise show first image as fallback.
      // We set display:'block' explicitly (not '') so the inline style overrides the
      // mobile CSS rule that hides non-first-child gallery items.
      if (matchingIds.size > 0) {
        items.forEach(item => {
          const imgId = parseInt(item.dataset.imageId);
          item.style.display = matchingIds.has(imgId) ? 'block' : 'none';
        });
      } else {
        // No matches at all (e.g., sold-out variant with no photos) —
        // fall back to showing the first product image.
        items.forEach((item, idx) => {
          item.style.display = idx === 0 ? 'block' : 'none';
        });
      }
    },

    updateAtcState(available) {
      const btn = document.getElementById('atc-button');
      if (!btn) return;
      btn.textContent = available ? 'ADD TO BAG' : 'SOLD OUT';
      btn.disabled = !available;
    },

    addToCart() {
      const btn = document.getElementById('atc-button');
      const inp = document.getElementById('variant-id-input');
      if (this.adding || btn.disabled) return;
      this.adding = true;
      const form = btn.form;
      const bundleToggle = form.querySelector('[data-tuxedo-toggle]');
      form.setAttribute('aria-busy', 'true');
      if (bundleToggle) bundleToggle.disabled = true;
      const orig = btn.textContent;
      btn.textContent = 'ADDING...';
      btn.disabled = true;

      fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(inp.value), quantity: 1 })
      })
        .then(async r => {
          const result = await r.json();
          if (!r.ok) throw new Error(result.description || 'Could not add to bag.');
          return result;
        })
        .then(() => {
          btn.textContent = orig;
          btn.disabled = false;
          CartDrawer.open();
        })
        .catch(error => {
          btn.textContent = orig;
          btn.disabled = false;
          Notification.show(error.message || 'Could not add to bag.');
        }).finally(() => {
          this.adding = false;
          form.removeAttribute('aria-busy');
          if (bundleToggle) bundleToggle.disabled = false;
        });
    }
  };

  /* ==========================================
     ACCORDION
  ========================================== */
  const Accordion = {
    init() {
      document.querySelectorAll('.accordion-item__trigger').forEach(trigger => {
        trigger.addEventListener('click', () => {
          const content = trigger.nextElementSibling;
          const isOpen = content.classList.contains('is-open');
          document.querySelectorAll('.accordion-item__content').forEach(c => c.classList.remove('is-open'));
          document.querySelectorAll('.accordion-item__trigger').forEach(t => t.classList.remove('is-open'));
          if (!isOpen) {
            content.classList.add('is-open');
            trigger.classList.add('is-open');
          }
        });
      });
    }
  };

  /* ==========================================
     NOTIFICATION TOAST
  ========================================== */
  const Notification = {
    el: null,
    timer: null,
    init() { this.el = document.getElementById('notification'); },
    show(msg, ms = 2500) {
      if (!this.el) return;
      this.el.textContent = msg;
      this.el.classList.add('is-visible');
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.el.classList.remove('is-visible'), ms);
    }
  };

  window.Notification = Notification;

  /* ==========================================
     INIT
  ========================================== */
  document.addEventListener('DOMContentLoaded', () => {
    CartDrawer.init();
    ProductForm.init();
    Accordion.init();
    Notification.init();

    // Policy and about pages: ensure white header
    if (window.location.pathname.includes('/policies/') || window.location.pathname.includes('/about')) {
      document.body.classList.add('template-policy');
    }
  });

})();
